export const Color = {
    brandYellow:"#fcf6d5",
    brandTeal:"#0ea79b",
    softTeal:"#8cd1ba",
    milkyTeal:"#c2e3c7",
    lightTeal:"#8ad0b8",
    peach:"#ffd683",
    papaya:"#ffbe0b",
    patternStrip:"#cccfb4",
    patternFill:"#ecf1d1",
    tan:"#a4867c",
    blackTeal:"#19322f",
    red:"#bc3554",
    brick: "#b01619",
    blackRed:"#4c1723",
    shadowTeal:"#72a795",
    shadowYellow:"#cac5aa",
    greyTeal:"#478f89",
    black:"#19322f",
    sepia:"#eadfc3",

    brandGreen: "#7ff800",
    white: "#ffffff",
    lightBlack: "#232323",
    darkBlack: "#171717",
    grey: "#717171",
    pink: "#ff014f",
    orange: "#ff8a00",
    darkGrey:"#161616",
    slateGrey: "#1e1e1e",
    softGrey: "#303030",
    blackGrey: "#0a0a0a",
    darkGreen:"#001b01",
    blackGreen:"#001000",
    middleGrey: "#484848",
    smokeGrey: "#cacaca",
    limeGreen:"#d2f800",
    silverGrey: "#5c5c5c",
    lightGreen: "#c3e3c7",

    sport: "#fa6200",

    vipYellow:"#f9c600",
    vipPurple:"#aa9aca",
    vipBlue:"#74adb3",

    yellow: "#ffff00",
    pear: "#d5ec37",
    inchWorm: "#7aec37",

    transparent: "transparent",

    scCards: "#12011A",
    roulBJ:"#071A01",
    vidPoker:"#000E24",
};